module.exports = __webpack_public_path__ + "img/wide.e15a53ab.jpg";